import { LandingTemplate } from "@/components/LandingTemplate";
import { IMG, FAQS } from "@/data/site";

const truckFaqs = FAQS.filter((f) => f.c === "Truck Parking" || f.c === "Parking");

export default function TruckParking() {
  return (
    <LandingTemplate
      seo={{
        title: "Hotel with Truck Parking in Ottawa, KS — Off I-35",
        description: "Free large-vehicle parking for semi-trucks, RVs and buses at Super 8 Ottawa, right off I-35 in Ottawa, Kansas. A truck-driver-friendly hotel with free breakfast, WiFi, laundry and easy highway access.",
        path: "/truck-parking",
        breadcrumbs: [{ name: "Home", path: "/" }, { name: "Truck Parking", path: "/truck-parking" }],
        faqs: truckFaqs,
      }}
      kicker="For Drivers & Crews"
      heroTitle="Truck & RV Parking"
      heroLines={["Room for", "whatever", "you drive"]}
      heroImage={IMG.truck}
      intro="We're the truck-friendly hotel drivers actually recommend. Free, oversized parking with outside electrical outlets, easy on-off access to I-35, a solid free breakfast and a comfortable bed — everything a long-haul day is missing."
      audiences={["Truck drivers", "CDL & commercial drivers", "RV travelers", "Oversized vehicles", "Construction equipment", "Work crews", "Long-haul drivers", "Road trips"]}
      features={[
        { icon: "Truck", title: "Free Oversized Parking", desc: "Plenty of room for semi-trucks, trailers, RVs and buses at no extra cost." },
        { icon: "Plug", title: "Outside Electrical Outlets", desc: "Exterior outlets for your convenience on the lot." },
        { icon: "Navigation", title: "Easy I-35 Access", desc: "Quick on and off the highway — no fighting through town." },
        { icon: "Coffee", title: "Free Hot-Start Breakfast", desc: "Fuel up before you roll out, on the house." },
        { icon: "WashingMachine", title: "Guest Laundry", desc: "Wash a load on the road so you arrive fresh." },
        { icon: "Wifi", title: "Free High-Speed WiFi", desc: "Handle logs, loads and calls with reliable internet." },
      ]}
      bandImage={IMG.truck2}
      bandTitle="Built for the road"
      bandText="Drivers keep coming back because the details are right: level, spacious parking you can actually maneuver, a 24-hour front desk for late arrivals, restaurants within walking distance, and a quiet room to rest before the next leg."
      benefits={[
        "Free large-vehicle & truck parking",
        "Outside electrical outlets",
        "24-hour front desk for late arrivals",
        "Restaurants within walking distance",
        "Quiet, comfortable rooms to actually rest",
        "Right off I-35 for a fast getaway",
      ]}
      keywords={["Hotel with truck parking Ottawa KS", "Truck driver hotel I-35", "RV parking hotel Kansas", "Hotel for CDL drivers", "Oversized vehicle parking hotel", "Bus parking hotel Ottawa"]}
      faqs={truckFaqs}
    />
  );
}
